import { ProjectRouteUpdatedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import { routeUpdatedNotification } from '../../../../notifications/routes/oldRouteNotifications';

export default ({ store, ...payload }: ProjectRouteUpdatedDtoModelType) => {
  getAppEnv(store).notification(routeUpdatedNotification(payload.routeId, payload.name));

  const rootStore = getAppRoot(store);
  rootStore.model.refreshCalendarRoutes();
};
